export default __webpack_public_path__ + "static/media/40-DTG-Fair-2019.b873e035.JPG";